import { Component, OnInit, ChangeDetectorRef , ViewChild, Output, EventEmitter, Input, ElementRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray , NgForm} from '@angular/forms';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { Address } from 'src/app/data/models/address.model';
import { CountryApiService } from 'src/app/modules/petitioner/services/country.service';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import { PhoneContact } from 'src/app/data/models/phone-contact.model';
import { EmailContact } from 'src/app/data/models/email-contact.model';
import { CompanyService } from 'src/app/services/company.service';
import { Company } from 'src/app/data/models/company.model';
import moment from 'moment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CompanyUtilityService } from 'src/app/modules/petitioner/services/utility.service';
import * as Roles from 'src/app/data/constants/roles';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FreeTrialService } from '../free-trial.service';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss']
})
export class CompanyInfoComponent implements OnInit {

  @Output () notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyInfo ;
  @Input() companyId;
  clientViewMode: boolean = false;
  @ViewChild('companyName', {static: true}) usernameElement: ElementRef;
  companyDetailsForm: FormGroup;
  listCountry: [];
  maxDate: Date;
  listStates: [];
  listStatesMail: [];
  viewModeCompanyId;
  attorneyClientCompId; 
  userType: string = '';
  businessTypeList: ReferenceLibrary[];
  addressTypeList: ReferenceLibrary[];
  phoneTypeList: ReferenceLibrary[];
  emailTypeList: ReferenceLibrary[];
  relationshipTypeList: ReferenceLibrary[];
  companyTypeList: ReferenceLibrary[];
  profileImage: any;
  companyCreationMode: string = '';
  companyDetailsDataSourceList;
  otherBusinessName: string = '';
  showOthername: boolean = false;
  isSameAddress: boolean;
  companyLogoImage: any;
  currentDate =  new Date();
  company = new Company({
    id: null,
    companyLogo: '',
    companyName: '',
    incorporationLoc: {
      countryCode: 'USA'
    },
    establishedDate: '',
    establishedYear: '',
    grossAnnualIncome: '',
    classification: '',
    netAnnualIncome: '',
    mgrExecUSCount: '',
    mgrExecNonUSCount: '',
    dotCode: '',
    naicsCode: '',
    othername: '',
    employeeCount: null,
    emailContacts: [],
    emailContact: new EmailContact(),
    altEmailContact: new EmailContact(),
    phoneContacts: [],
    phoneContact: {
      id: null,
      countryCode: 'USA'
    },
    mobileContact: {
      id: null,
      countryCode: 'USA'
    },
    address: [new Address({}), new Address({})],
    businessType: []
  });
  uploadedFile: any;
  destroy$ = new Subject<void>();
  formChangesSubscription: any;
  dirtyFlag: boolean = false;
  @ViewChild('f', { static: false }) compDetailForm: NgForm;
  observableSubscription$ = new Subject();
  disableFields = false;
  editCompanyId;
  getCompanyName: any;
  otherValue: any;

  constructor(private fb: FormBuilder,
              public sanitizer: DomSanitizer,
              protected store: Store<any>,
              public dialog: MatDialog,
              private cacheCountryService: CacheCountryService,
              private referenceLibraryService: ReferenceLibraryService,
              private changeDetectorRef: ChangeDetectorRef,
              private utility: CompanyUtilityService,
              private apiService: CountryApiService,
              private router: Router,
              private toastr: ToastrService,
              private activatedRoute: ActivatedRoute,
              private companyService: CompanyService,
              private freeTrialService: FreeTrialService,
              usernameElement: ElementRef) {
    this.usernameElement = this.companyInfo;
    this.viewModeCompanyId = '';
    this.attorneyClientCompId = '';
    this.listStates = [];
    this.listStatesMail = [];
    this.listCountry = [];
    this.userType = sessionStorage.getItem('userTypeRole');
    this.utility.checkCompanyIdFlag();
    this.referenceLibraryService.getReferenceDataWithoutAuthentication('BUSTYP').subscribe((data: ReferenceLibrary[]) => {
      this.businessTypeList = data;
    });
    this.referenceLibraryService.getReferenceData('ADDR').subscribe((data: ReferenceLibrary[]) => {
      this.addressTypeList = data;
    });
    this.referenceLibraryService
      .getReferenceData('PHON')
      .subscribe((response: ReferenceLibrary[]) => {
        this.phoneTypeList = response;
      });
    this.referenceLibraryService
      .getReferenceData('EMLTYP')
      .subscribe((response: ReferenceLibrary[]) => {
        this.emailTypeList = response;
      });
    this.referenceLibraryService
      .getReferenceData('COMPRELTYP')
      .subscribe((response: ReferenceLibrary[]) => {
        this.relationshipTypeList = response;
      });
    this.referenceLibraryService
      .getReferenceData('COMPTYP')
      .subscribe((response: ReferenceLibrary[]) => {
        this.companyTypeList = response;
      });
    this.maxDate = new Date();
    
    }

  ngOnInit() {

    this.activatedRoute.queryParams
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe(params => {
      this.getCompanyName = localStorage.getItem("companyname");
    }
  );
    this.cacheCountryService.getCountry().subscribe(data => {
      if (data.length > 0) {
        this.listCountry = data.map(x => {
          return {
            ...x,
            countryPhoneCode: `${x.countryCode} - ${x.phoneCode}`
          };
        });
      }
    });
    this.companyDetailsForm = this.fb.group({
      companyName: ['', Validators.required],
      businessType: ['', Validators.required]
    });
    let modeOfCreation =  this.activatedRoute.snapshot.queryParamMap.get('modeOfCreation');
    this.activatedRoute.params
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(parameter => {
        let parameterId = null;
        if (parameter.hasOwnProperty('id')) {
          this.editCompanyId = parameterId;
          this.companyService.getCompaniesById(parameter.id).subscribe(data => {
            this.companyDetailsDataSourceList = data;
            if(data.status.code == 'ACTV' && modeOfCreation == 'INVITED')
              this.disableFields = true;
            this.mapCompanyDetails();
          });
        } else {

        }
      });

    this.company.address[0].countryCode = 'USA';
    this.company.address[1].countryCode = 'USA';
    this.handleCountryChange('USA', 'reg');
    this.handleCountryChange('USA', 'mail');
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit() {
    this.formChangesSubscription = this.compDetailForm.statusChanges.subscribe(() => {
      if (this.compDetailForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
        this.dirtyFlag = true;
      }
      else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.dirtyFlag = false;
      }
    });
  }

  copyAddress(e) {
    if (e.checked) {
      this.company.address[1].addressLine1 = this.company.address[0].addressLine1;
      this.company.address[1].addressLine2 = this.company.address[0].addressLine2;
      this.company.address[1].countryCode = this.company.address[0].countryCode;
      this.company.address[1].stateProvinceCode = this.company.address[0].stateProvinceCode;
      this.company.address[1].stateProvinceName = this.company.address[0].stateProvinceName;
      this.company.address[1].city = this.company.address[0].city;
      this.company.address[1].postCode = this.company.address[0].postCode;
      if (this.company.address[1].countryCode) {
        let mailcode = this.company.address[1].countryCode;
        this.handleCountryChange(mailcode, 'mail');
      }
    } else {
      this.company.address[1].addressLine1 = '';
      this.company.address[1].addressLine2 = '';
      this.company.address[1].countryCode = '';
      this.company.address[1].stateProvinceCode = '';
      this.company.address[1].stateProvinceName = '';
      this.company.address[1].city = '';
      this.company.address[1].postCode = '';
    }
  }

  mapCompanyDetails() {
    this.businessTypeList;
    this.otherBusinessName = '';
    this.showOthername = false;
    this.company = new Company({
      id: this.companyDetailsDataSourceList.id,
      companyLogo: this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.companyLogo,
      companyName:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.companyName,
      incorporationLoc: {
        countryCode:
          this.companyDetailsDataSourceList.incorporationLoc &&
          this.companyDetailsDataSourceList.incorporationLoc.countryCode
      },
      establishedDate: this.companyDetailsDataSourceList &&
        moment(this.companyDetailsDataSourceList.establishedDate).format('MM-DD-YYYY'),
      establishedYear: this.companyDetailsDataSourceList && this.companyDetailsDataSourceList.establishedYear,
      grossAnnualIncome:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.grossAnnualIncome,
      classification:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.classification,
      netAnnualIncome:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.netAnnualIncome,
      mgrExecUSCount:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.mgrExecUSCount,
      mgrExecNonUSCount:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.mgrExecNonUSCount,
      feiNo:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.feiNo,
      companyCode:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.companyCode,
      dotCode:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.dotCode,
      naicsCode:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.naicsCode,
      employeeCount:
        this.companyDetailsDataSourceList &&
        this.companyDetailsDataSourceList.employeeCount,
      emailContacts: [],
      emailContact: new EmailContact(),
      altEmailContact: new EmailContact(),
      phoneContacts: [],
      phoneContact: new PhoneContact(),
      mobileContact: new PhoneContact(),
      address: [],
      businessType: []
    });
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.companyDetailsDataSourceList.businessType.length; i++) {
      //const id = this.companyDetailsDataSourceList.businessType[i].typeId.id;
      let obj = this.businessTypeList.find(x => x.id === this.companyDetailsDataSourceList.businessType[i].typeId.id);
      this.company.businessType.push(obj);
      if (this.companyDetailsDataSourceList.businessType[i].typeId.code === 'OTHER') {
        this.otherBusinessName = this.companyDetailsDataSourceList.businessType[i].otherBusTypeName;
        this.showOthername = true;
      }
    }
    const email = new EmailContact();
    email.id = this.companyDetailsDataSourceList.emailContacts.find(
      x => x.type.code === 'PRIM'
    )
      ? this.companyDetailsDataSourceList.emailContacts.find(
        x => x.type.code === 'PRIM'
      ).id
      : '';
    email.type = {
      id: this.companyDetailsDataSourceList.emailContacts.find(
        x => x.type.code === 'PRIM'
      )
        ? this.companyDetailsDataSourceList.emailContacts.find(
          x => x.type.code === 'PRIM'
        ).type.id
        : ''
    };
    email.email = this.companyDetailsDataSourceList.emailContacts.find(
      x => x.type.code === 'PRIM'
    )
      ? this.companyDetailsDataSourceList.emailContacts.find(
        x => x.type.code === 'PRIM'
      ).email
      : '';
    this.company.emailContact = email;

    const altEmail = new EmailContact();
    altEmail.id = this.companyDetailsDataSourceList.emailContacts.find(
      x => x.type.code === 'ALT'
    )
      ? this.companyDetailsDataSourceList.emailContacts.find(
        x => x.type.code === 'ALT'
      ).id
      : '';
    altEmail.type = {
      id: this.companyDetailsDataSourceList.emailContacts.find(
        x => x.type.code === 'ALT'
      )
        ? this.companyDetailsDataSourceList.emailContacts.find(
          x => x.type.code === 'ALT'
        ).type.id
        : ''
    };
    altEmail.email = this.companyDetailsDataSourceList.emailContacts.find(
      x => x.type.code === 'ALT'
    )
      ? this.companyDetailsDataSourceList.emailContacts.find(
        x => x.type.code === 'ALT'
      ).email
      : '';
    this.company.altEmailContact = altEmail;

    // Filling phone contact details
    const phone = new PhoneContact();
    phone.id = this.companyDetailsDataSourceList.phoneContacts.find(
      x => x.type.code === 'OFFC'
    )
      ? this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'OFFC'
      ).id
      : '';
    phone.countryCode = this.companyDetailsDataSourceList.phoneContacts.find(
      x => x.type.code === 'OFFC'
    )
      ? this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'OFFC'
      ).countryCode.countryCode
      : '';
    phone.phoneNo = this.companyDetailsDataSourceList.phoneContacts.find(
      x => x.type.code === 'OFFC'
    )
      ? this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'OFFC'
      ).phoneNo
      : '';
    phone.type = {
      id: this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'OFFC'
      )
        ? this.companyDetailsDataSourceList.phoneContacts.find(
          x => x.type.code === 'OFFC'
        ).type.id
        : ''
    };
    this.company.phoneContact = phone;

    const mobile = new PhoneContact();

    mobile.id = this.companyDetailsDataSourceList.phoneContacts.find(
      x => x.type.code === 'MOBL'
    )
      ? this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'MOBL'
      ).id
      : '';
    mobile.countryCode = this.companyDetailsDataSourceList.phoneContacts.find(
      x => x.type.code === 'MOBL'
    )
      ? this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'MOBL'
      ).countryCode.countryCode
      : '';

    mobile.phoneNo = this.companyDetailsDataSourceList.phoneContacts.find(
      x => x.type.code === 'MOBL'
    )
      ? this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'MOBL'
      ).phoneNo
      : '';
    mobile.type = {
      id: this.companyDetailsDataSourceList.phoneContacts.find(
        x => x.type.code === 'MOBL'
      )
        ? this.companyDetailsDataSourceList.phoneContacts.find(
          x => x.type.code === 'MOBL'
        ).type.id
        : ''
    };
    this.company.mobileContact = mobile;
    //const codeReg = this.companyDetailsDataSourceList && this.companyDetailsDataSourceList.address.find(x => x.type.code === 'REGS') ? this.companyDetailsDataSourceList.address.find(x => x.type.code === 'REGS').countryCode.countryCode : '';
    // Filling address
    this.addAddress('REGS');
    this.addAddress('MAIL');
    if (this.company.address && this.company.address.length > 0) {
      if (this.company.address[0] && this.company.address[0].countryCode) {
        let code = this.company.address[0].countryCode;
        this.handleCountryChange(code, 'reg');
      }
      if (this.company.address[1] && this.company.address[1].countryCode) {
        let mailcode = this.company.address[1].countryCode;
        this.handleCountryChange(mailcode, 'mail');
      }
    }
    this.isSameAddress = true;
    this.checkedAddress();
    this.profileImage =  (this.company.companyLogo) ? 'data:image/jpeg;base64,' + this.company.companyLogo : null;
    this.companyLogoImage = (this.company.companyLogo) ? 'data:image/jpeg;base64,' + this.company.companyLogo : null;//'../../../../../assets/cameraIcon.png';
    //this.company.companyLogo ? sessionStorage.setItem('companyLogo', this.company.companyLogo) : sessionStorage.removeItem('companyLogo');
  }

  handleCountryChange(countryCode, stateIndex) {
    this.apiService.getStates(countryCode).subscribe((states: []) => {
      switch (stateIndex) {
        case 'reg':
          this.listStates = states;
          break;
        case 'mail':
          this.listStatesMail = states;
          break;
      }
      this.changeDetectorRef.markForCheck();
    });
  }

  addAddress(addressType: string) {
    if (this.companyDetailsDataSourceList && this.companyDetailsDataSourceList.address && this.companyDetailsDataSourceList.address.length > 0) {
      const address = this.companyDetailsDataSourceList.address.filter(x => x.type.code === addressType)[0];
      if (address) {
        this.company.address.push({
          id: address['id'],
          addressLine1: address['addressLine1'],
          addressLine2: address['addressLine2'],
          city: address['city'],
          // countryCode: (addressType == 'REGS')? 'USA' : address['countryCode']['countryCode'],
          countryCode: address['countryCode'] && address['countryCode']['countryCode'] ?
            address['countryCode']['countryCode'] : ((addressType === 'REGS') ? 'USA' : null),
          doorNo: address['doorNo'],
          postCode: address['postCode'],
          stateProvinceCode: address['stateProvinceCode'],
          stateProvinceName: address['stateProvinceName'],
          streetNo: address['streetNo'],
          toDate: address['toDate'],
          type: {
            id: address['type']['id']
          }
        });
      } else {
        this.blankCompanyDetails(addressType);
      }
    } else {
      this.blankCompanyDetails(addressType);
    }
  }

  checkedAddress() {
    if (this.company.address[1].addressLine1 != this.company.address[0].addressLine1) {
      this.isSameAddress = false;
    }
    if (this.company.address[1].addressLine2 != this.company.address[0].addressLine2) {
      this.isSameAddress = false;
    }
    if (this.company.address[1].countryCode != this.company.address[0].countryCode) {
      this.isSameAddress = false;
    }
    if (this.company.address[1].stateProvinceCode != this.company.address[0].stateProvinceCode) {
      this.isSameAddress = false;
    }
    if (this.company.address[1].stateProvinceName != this.company.address[0].stateProvinceName) {
      this.isSameAddress = false;
    }
    if (this.company.address[1].city != this.company.address[0].city) {
      this.isSameAddress = false;
    }
    if (this.company.address[1].postCode != this.company.address[0].postCode) {
      this.isSameAddress = false;
    }
  }

  onNext() {
    this.notify.emit(1);
  }

  onCancel(){
    if (this.dirtyFlag) {

      this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!',
            message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
          },
          // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
          buttons: ['No', 'Yes'],
          disableClose: true
        }
      }).afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
          this.dirtyFlag = false;
          this.router.navigate([`/login/login/signin`]);
        }
      });

    } else {
      this.router.navigate([`/login/login/signin`]);
    }

  }


  blankCompanyDetails(addressType) {
    this.company.address.push({
      id: null,
      addressLine1: null,
      addressLine2: null,
      city: null,
      countryCode: (addressType == 'REGS') ? 'USA' : null,
      doorNo: null,
      postCode: null,
      stateProvinceCode: null,
      stateProvinceName: null,
      streetNo: null,
      toDate: null,
      type: {
        id: this.addressTypeList.filter(x => x.code === addressType)[0]['id']
      }
    });
  }

  companyDetailsFormSub() {
    const payload = {
      relationShip: {
        id: 46
      },
      relatedCompany: null,
      company: {
        id: null,
        companyLogo: '',
        companyCode: this.company.companyCode,
        companyName:  this.getCompanyName,
        feiNo: this.company.feiNo,
        incorporationLoc: this.company.incorporationLoc,
        establishedDate: this.company.establishedDate ? moment(this.company.establishedDate).format('YYYY-MM-DD') : '',
        establishedYear: this.company.establishedYear,
        phoneContacts: [],
        address: [],
        address1: this.company.address[0].addressLine1,
        address2: this.company.address[1].addressLine1,
        city: this.company.address[0].city,
        postCode: this.company.address[0].postCode,
        stateProvinceCode: this.company.address[0].stateProvinceCode,
        countryCodeAdd: this.company.address[0].countryCode,
        emailContact: this.company.emailContact,
        altEmailContact: this.company.altEmailContact,
        mobileContacts: this.company.mobileContact,
        phoneContactss: this.company.phoneContact,
        countryCode: this.company.phoneContact.countryCode,
        countryCodemobile: this.company.mobileContact.countryCode,
        employeeCount: this.company.employeeCount,
        grossAnnualIncome: this.company.grossAnnualIncome,
        //classification: this.company.classification,
        netAnnualIncome: this.company.netAnnualIncome,
        mgrExecUSCount: this.company.mgrExecUSCount,
        mgrExecNonUSCount: this.company.mgrExecNonUSCount,
        //dotCode: this.company.dotCode,
        naicsCode: this.company.naicsCode,
        businessType: this.company.businessType,
        othername: this.company.otherBusinessName
      }
    };
    let estdDateYearErrorMsg = '';
    if(!this.company.establishedDate && !this.company.establishedYear){
      estdDateYearErrorMsg = 'Please provide Established Date OR Established Year';
    }else if(this.company.establishedDate && this.company.establishedYear){
      let yearFromDate = moment(this.company.establishedDate).format('YYYY');
      if(yearFromDate !== String(this.company.establishedYear)){
        estdDateYearErrorMsg = 'Established date year and Established year should be same';
      }
    }
    if(estdDateYearErrorMsg){
      CustomErrorToastComponent.showErrorToast(this.toastr, estdDateYearErrorMsg);
    }else if (this.company.emailContact.email === this.company.altEmailContact.email) {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Primary email and alternate email should not be the same');
    } else {
      this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      this.dirtyFlag = false;
      this.toastr.success('Info saved successfully', 'Success');
      this.freeTrialService.setcompanyInfo(payload);
      this.companyDetailsForm.reset();
      this.notify.emit(1);
    }
  }

  returnAddress(index, addressType) {
    return {
      id: this.company.address && this.company.address[index].id ? this.company.address[index].id : null,
      addressLine1: this.company.address[index].addressLine1,
      addressLine2: this.company.address[index].addressLine2,
      city: this.company.address[index].city,
      countryCode: {
        countryCode: this.company.address[index].countryCode
      },
      doorNo: this.company.address[index].doorNo,
      fromDate: this.company.address[index].fromDate,
      postCode: this.company.address[index].postCode,
      stateProvinceCode: this.company.address[index].stateProvinceCode,
      stateProvinceName: this.company.address[index].stateProvinceName,
      streetNo: this.company.address[index].streetNo,
      toDate: this.company.address[index].toDate,
      type: {
        id: this.addressTypeList.find(x => x.code === addressType)
          ? this.addressTypeList.find(x => x.code === addressType).id
          : null,
        code: addressType
      }
    }
  }


  saveLogo(companyId) {
    //IM-3840
    if (this.profileImage) {
      let fd = new FormData();
      fd.append("file", this.profileImage, 'logo.png');
      this.companyService.updateProfilePic(parseInt(companyId), fd).subscribe((response) => {
        if (response['status'] === 200) {
          this.companyLogoImage = 'data:image/jpeg;base64,' + response['data']['companyLogo'];
          this.company.companyLogo = this.companyLogoImage;
          this.profileImage = this.companyLogoImage;
          //this.toastr.success('Image Uploaded successfully');
        }
        else {
          CustomErrorToastComponent.showErrorToast(this.toastr, 'Image is not Uploaded');
        }
      });
    }
    
  }

  onUpload(event,fileUpload) {
    for(let file of event.files) {
      this.uploadedFile = file;
    }

    this.companyLogoImage = this.sanitizer.bypassSecurityTrustUrl(this.uploadedFile.objectURL.changingThisBreaksApplicationSecurity);
    this.profileImage = this.uploadedFile;
    this.company.companyLogo = this.uploadedFile;
    const file = this.uploadedFile;
    let fd = new FormData();
    fd.append("file", file, 'logo.png');
    fileUpload.clear();
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  onBusinessTypeChange(selectedValues, e) {
    let codes = [];
    if (selectedValues && selectedValues.length > 0) {
      selectedValues.forEach(el => {
        codes.push(el.code);
      });
      if (codes.length > 0 && codes.indexOf('OTHER') >= 0) {
        this.showOthername = true;
      } else {
        this.showOthername = false;
      }
    }
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }

}
